
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { ValidationProvider } from "vee-validate";
import FormGroup from "@/components/form/FormGroupNew.vue";
import FormInputGroup from "@/components/form/FormInputGroupNew.vue";
import FormMultiselect from "@/components/form/FormSelectNew.vue";
import _ from "lodash";

@Component({
  components: {
    ValidationProvider,
    FormGroup,
    FormInputGroup,
    FormMultiselect,
  },
})
export default class PersonalConsiderations extends Vue {
  @Prop({ required: true }) readonly formData!: Record<string, any>;

  petOptions = [
    { label: "Dog", value: "Dog" },
    { label: "Cat", value: "Cat" },
    { label: "Bird", value: "Bird" },
    { label: "Fish", value: "Fish" },
  ];

  hobbyOptions = [
    { label: "Reading", value: "Reading" },
    { label: "Gardening", value: "Gardening" },
    { label: "Music", value: "Music" },
    { label: "Art", value: "Art" },
    { label: "Exercise", value: "Exercise" },
  ];
  localFormData: Record<string, any> = {};

  @Watch("formData", { immediate: true, deep: true })
  onFormDataChange(newVal: Record<string, any>) {
    this.localFormData = _.cloneDeep(newVal);
  }

  updateField(field: string, value: any) {
    this.localFormData[field] = value;
    this.$emit("update:formData", this.localFormData);
  }
}
